import React from 'react';
import { Button } from '@etherisc/ui-kit';
import { AlertTriangleIcon } from 'lucide-react';
import type { ButtonProps } from '@etherisc/ui-kit';

interface DangerButtonProps extends Omit<ButtonProps, 'variant' | 'children'> {
  children: React.ReactNode;
  showIcon?: boolean;
  iconSize?: number;
  fullWidth?: boolean;
  wide?: boolean;
}

/**
 * Semantic button component for Dangerous/Destructive actions
 * Uses RED color following UX guidelines for potentially harmful actions
 * Examples: Delete, Remove, Reset, Reject
 * Includes optional warning icon for destructive actions
 * Uses @etherisc/ui-kit Button with variant="destructive"
 */
export function DangerButton({ 
  children, 
  showIcon = true, 
  iconSize = 16,
  fullWidth = false,
  wide = false,
  className = '',
  ...props 
}: DangerButtonProps) {
  // Handle sizing classes - adapt to ui-kit if needed
  const sizeClasses = fullWidth ? 'w-full max-w-[500px]' : wide ? 'w-48' : '';
  const combinedClassName = `flex items-center gap-2 ${sizeClasses} ${className}`.trim();
  
  return (
    <Button 
      {...props}
      variant="danger"
      className={combinedClassName}
    >
      {showIcon && <AlertTriangleIcon size={iconSize} />}
      {children}
    </Button>
  );
}

 